const getFocusableElements = (element = document) => {
  return Array.from(
    element.querySelectorAll(
      'a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
    )
  ).filter((el) => !el.hasAttribute("disabled"));
};
export default getFocusableElements;
